<template>
  <ContentList :list="sizeAndFit">
    <template #default="{ item }">
      <span v-html="item"></span>
    </template>
  </ContentList>
</template>

<script setup>
import ContentList from '~/components/common/ContentList';
import { useProductDetails } from '../composables/useProductDetails';

const { sizeAndFit } = useProductDetails();
</script>
